import { theme } from '@pocketlaw/tetris';
export function getTheme(name) {
    const themes = {
        mono: {
            single: [theme.swatches.warm[1000]],
            line: [theme.swatches.warm[1000]],
            breakdown: [theme.swatches.warm[1000]],
        },
        'mono-shaded': {
            single: [theme.swatches.warm[1000], theme.swatches.warm[700]],
            line: [theme.swatches.warm[1000]],
            breakdown: [theme.swatches.warm[1000], theme.swatches.warm[700]],
        },
        blue: {
            single: [theme.swatches.blue[300]],
            line: [theme.swatches.blue[400]],
            breakdown: [theme.swatches.blue[300]],
        },
        'blue-shaded': {
            single: [theme.swatches.blue[300], theme.swatches.blue[100]],
            line: [theme.swatches.blue[400]],
            breakdown: [theme.swatches.blue[300], theme.swatches.blue[100]],
        },
        'two-color': {
            single: [theme.swatches.orange[400], theme.swatches.blue[300]],
            line: [theme.swatches.blue[400]],
            breakdown: [theme.swatches.orange[400], theme.swatches.blue[300]],
        },
        'multi-color': {
            single: [
                theme.swatches.blue[300],
                theme.swatches.orange[300],
                theme.swatches.indigo[300],
                theme.swatches.yellow[300],
                theme.swatches.teal[300],
                theme.swatches.red[300],
                theme.swatches.magenta[300],
            ],
            line: [theme.swatches.blue[300]],
            breakdown: [
                theme.swatches.blue[300],
                theme.swatches.orange[300],
                theme.swatches.indigo[300],
                theme.swatches.yellow[300],
                theme.swatches.teal[300],
                theme.swatches.red[300],
                theme.swatches.magenta[300],
            ],
        },
    };
    const scheme = name && themes[name] ? themes[name] : themes.mono;
    return (type, index = 0) => scheme[type][index % scheme[type].length];
}
